import ParameterErrors from '../errors/ParameterErrors';
import EulerAngles from '../geometry/EulerAngles';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class SiteJsonFileUnitNearestOutside360Move{
	constructor(props){
		const {outside360UniqueId, cameraAngleToFaceFrontDoor}=props;
		if(outside360UniqueId===undefined||outside360UniqueId===null)
			throwNotProvided('outside360UniqueId');
		this._outside360UniqueId = outside360UniqueId;
		//if(cameraAngleToFaceFrontDoor===undefined||cameraAngleToFaceFrontDoor===null)
		//	throwNotProvided('cameraAngleToFaceFrontDoor');
		this._cameraAngleToFaceFrontDoor = cameraAngleToFaceFrontDoor;
	}
	get cameraAngleToFaceFrontDoor(){
		return this._cameraAngleToFaceFrontDoor;
	}
	get outside360UniqueId(){
		return this._outside360UniqueId;
	}
	static fromJSON(jObject){
		return new SiteJsonFileUnitNearestOutside360Move({
			outside360UniqueId:jObject.outside360UniqueId,
			cameraAngleToFaceFrontDoor:jObject.cameraAngleToFaceFrontDoor?EulerAngles.fromJSON(jObject.cameraAngleToFaceFrontDoor):null
		});
	}
}